import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  DataGridGroup,
  useResponsiveParams,
  Text,
  Button,
  NotificationList,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import {
  GET_DATE_TIME,
  SEND_PROPOSAL_PDF,
  LOB_PRODUCT_LIST,
  PROPOSAL_PAYMENT_TYPE_LIST,
} from '../queries';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';
import { CurrencyFormater } from 'quanta-flows';
import {
  faDownload,
  faExternalLinkAlt,
  faEye,
  faInfoCircle,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalViewBreakupTW } from 'quanta-flows/modules/common/viewBreakUp';
import { useMutationQuery } from 'quanta-flows';
import { useFetchQuery } from 'quanta-flows';
import CoverDataModal from '../wizard-panel/cover-data-modal';

export default function ProposalSummary({
  data: dataBuyMotorPolicy,
  productName,
  productCode,
  productType,
  lobCode,
  lobName,
}) {
  const [alerts, setAlerts] = useState([]);
  const mutateQuery = useMutationQuery();
  const fetchQuery = useFetchQuery();
  const [showViewBreakup, setShowViewBreakup] = useState(false);
  const [showCoversModal, setShowCoversModal] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [mounted, setMounted] = useState(false);
  const repeatForMobile = 2,
    repeatForDesktop = 1,
    repeatForIPad = 4;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
    for_iPad: repeatForIPad,
  });
  const product_name = productName
  ? productName
  : params?.product_name;

const product_code  = productCode
?productCode
:params?.product_code;
  let screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
    for_iPad: 'iPad',
  });

  const {
    loading: loadingLobList,
    error: errorLobList,
    data: dataLobList,
  } = useQuery(LOB_PRODUCT_LIST, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: list_loading,
    error: error_list,
    data: ListDetails,
  } = useQuery(PROPOSAL_PAYMENT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    let isMounted = true;
    if (
      dataBuyMotorPolicy &&
      ListDetails &&
      dataLobList &&
      !mounted
    ) {
      setMounted(true);
    }
    return () => {
      isMounted = false;
    };
  }, [mounted, dataBuyMotorPolicy, dataLobList, ListDetails]);

  const getBase64Var = (buyMotorPolicyData, getDateTimeData) => {
    let riskInput = [];
    buyMotorPolicyData?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      buyMotorPolicy?.quoteData?.coverData?.addOnCovers
        ?.find(
          (riskCover) =>
            riskCover?.riskType?.toString()?.toLowerCase() ===
            r?.riskType?.toString()?.toLowerCase(),
        )
        ?.covers?.filter(
          (cover) =>
            !r?.covers?.find(
              (cov) =>
                cov?.name?.toString()?.toLowerCase() ===
                cover?.name?.toString()?.toLowerCase(),
            ),
        )
        ?.forEach((cover) => {
          covers?.push({
            name: cover?.name ? `${cover?.name}` : '',
            index: cover?.index ? `${cover?.index}` : '',
            attributes: [],
          });
        });
      r.covers
        .filter(
          (c) =>
            buyMotorPolicyData?.coverData?.addOnCovers[c?.name]
              ?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    buyMotorPolicyData?.coverData?.addOnCovers[
                      `${c?.name}`
                    ][`attributes`][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        quoteNumber: buyMotorPolicyData?.quoteNumber
          ? `${buyMotorPolicyData?.quoteNumber}`
          : '',
        productCode,
        productType: buyMotorPolicyData?.productType
          ? `${buyMotorPolicyData?.productType}`
          : '',
        customerType: buyMotorPolicyData?.proposerDetails
          ?.customerType
          ? `${buyMotorPolicyData?.proposerDetails?.customerType}`
          : '',
        gender: buyMotorPolicyData?.proposerDetails?.gender
          ? `${buyMotorPolicyData?.proposerDetails?.gender}`
          : '',
        businessType: buyMotorPolicyData?.businessType
          ? `${buyMotorPolicyData?.businessType}`
          : '',
        intermediary: {
          intermediaryCode: buyMotorPolicyData?.intermediaryDetails
            ?.code
            ? `${buyMotorPolicyData?.intermediaryDetails?.code}`
            : '',
          locationCode: buyMotorPolicyData?.intermediaryDetails
            ?.location
            ? `${buyMotorPolicyData?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: buyMotorPolicyData?.intermediaryDetails
            ?.fieldUserCode
            ? `${buyMotorPolicyData?.intermediaryDetails?.fieldUserCode}`
            : '',
        },
        tenure:
          buyMotorPolicyData?.quoteData?.tenure ||
          buyMotorPolicyData?.quoteData?.premiumData?.tenure ||
          buyMotorPolicyData?.premiumData?.tenure
            ? `${
                buyMotorPolicyData?.quoteData?.tenure ||
                buyMotorPolicyData?.quoteData?.premiumData?.tenure ||
                buyMotorPolicyData?.premiumData?.tenure
              }`
            : '',
        rto: {
          rtoAuthCode: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
            : '',
          rtoLocCode: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationCode
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationCode}`
            : '',
          rtoLocDesc: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`
            : '',
        },
        vehicle: {
          make: buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails
            ?.make?.code
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.make?.code}`
            : '',
          model: buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails
            ?.model?.code
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.model?.code}`
            : '',
          variant: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.variant?.code
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.variant?.code}`
            : '',
          engineNumber: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
            : '',
          chasisNumber: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
            : '',
          registrationNumber: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
            : '',
          manufactureYear: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.yearOfManufacture
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.yearOfManufacture}`
            : '',
          regPurchaseDate: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.dateOfRegistration
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.dateOfRegistration}`
            : '',
          fuelType: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.fuelType
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.seatingCapacity
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.seatingCapacity}`
            : '',
          cubicCapacity: buyMotorPolicyData?.vehicleTabDetails
            ?.vehicleDetails?.cubeCapacity
            ? `${buyMotorPolicyData?.vehicleTabDetails?.vehicleDetails?.cubeCapacity}`
            : '',
        },
        firstYearIDV:
          buyMotorPolicyData?.vehicleTabDetails
            ?.insuredDeclaredDetails?.vehicleIDV !== null &&
          buyMotorPolicyData?.vehicleTabDetails
            ?.insuredDeclaredDetails?.vehicleIDV !== undefined
            ? `${buyMotorPolicyData?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`
            : '',
        irf1: buyMotorPolicyData?.vehicleTabDetails
          ?.insuredDeclaredDetails?.irfAdjustmentPercent
          ? `${buyMotorPolicyData?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}`
          : '',
        prevInsurance: {
          coverType: buyMotorPolicyData?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyCoverType
            ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
            : '',
          policyTenure: buyMotorPolicyData?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyTenure
            ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
            : '',
          insurerName: buyMotorPolicyData?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.previousInsurerName
            ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
            : '',
          policyNumber: buyMotorPolicyData?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.expiringPolicyNumber
            ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
            : '',
          startDate: buyMotorPolicyData?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyStartDate
            ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
            : '',
          expiryDate: buyMotorPolicyData?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyExpiryDate
            ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
            : '',
        },
        prevClaims: {
          totalClaimCount:
            buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'annual'
              ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
              : '',
          claimsInYear1:
            buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
              : '',
          claimsInYear2:
            buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
              : '',
          claimsInYear3:
            buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
              : '',
          prevNCBSlab: buyMotorPolicyData?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims?.prevNCBSlab
            ? `${buyMotorPolicyData?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.prevNCBSlab}`
            : '',
          totalClaimAmount:
            buyMotorPolicyData?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== undefined &&
            buyMotorPolicyData?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== null
              ? parseFloat(
                  buyMotorPolicyData?.additionalTabDetails
                    ?.previousInsuranceAndClaims?.previousClaims
                    ?.totalClaimAmount,
                )
              : null,
          claimFreeYear:
            buyMotorPolicyData?.premiumData?.claimFreeYear,
        },
        financerDetails: {
          financerName:
            buyMotorPolicyData?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicyData?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.financerName
              : '',
          financerAddress:
            buyMotorPolicyData?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicyData?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.financerAddress
              : '',
          financerAgreementType:
            buyMotorPolicyData?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicyData?.additionalTabDetails
                  ?.financeDetails?.financerDetails
                  ?.financerAgreementType
              : '',
          loanAccountNumber:
            buyMotorPolicyData?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicyData?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.loanAccountNumber
              : '',
          fileNumber:
            buyMotorPolicyData?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicyData?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.fileNumber
              : '',
        },
        riskCovers: riskInput,
        proposerPincode: buyMotorPolicyData?.quoteData?.pincode,
        creditScore: {
          discountOpted:
            buyMotorPolicyData?.quoteData
              ?.getAdditionalCreditScore === 'Yes',
          idProofType: buyMotorPolicyData?.quoteData?.idProofType,
          idProofNumber: buyMotorPolicyData?.quoteData?.idProofNumber,
          creditScore:
            buyMotorPolicyData?.quoteData?.premiumData
              ?.creditScore !== null &&
            buyMotorPolicyData?.quoteData?.premiumData
              ?.creditScore !== undefined
              ? parseFloat(
                  buyMotorPolicyData?.quoteData?.premiumData
                    ?.creditScore,
                )
              : null,
        },
        voluntaryDeductibleAmt:
          buyMotorPolicyData?.quoteData?.voluntaryDeductibleAmount !==
            null &&
          buyMotorPolicyData?.quoteData?.voluntaryDeductibleAmount !==
            undefined
            ? parseInt(
                buyMotorPolicyData?.quoteData
                  ?.voluntaryDeductibleAmount,
              )
            : null,
            NCB:
            buyMotorPolicyData?.quoteData?.NCB !==
              null &&
            buyMotorPolicyData?.quoteData?.NCB !==
              undefined
              ? parseFloat(
                  buyMotorPolicyData?.quoteData
                    ?.NCB,
                )
              : null,
        customer: {
          id: buyMotorPolicyData?.proposerDetails?.id,
          customerType:
            buyMotorPolicyData?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: buyMotorPolicyData?.proposerDetails?.title,
          firstName: buyMotorPolicyData?.proposerDetails?.firstName,
          middleName: buyMotorPolicyData?.proposerDetails?.middleName,
          lastName: buyMotorPolicyData?.proposerDetails?.lastName,
          fullName: buyMotorPolicyData?.proposerDetails?.fullName,
          gender: buyMotorPolicyData?.proposerDetails?.gender,
          proposerDOB:
            buyMotorPolicyData?.proposerDetails?.proposerDOB,
          orgName: buyMotorPolicyData?.proposerDetails?.orgName,
          orgType: buyMotorPolicyData?.proposerDetails?.orgType,
          contactName:
            buyMotorPolicyData?.proposerDetails?.contactName,
          regNumber: buyMotorPolicyData?.proposerDetails?.regNumber,
          tanNumber: buyMotorPolicyData?.proposerDetails?.tanNumber,
          gstNumber: buyMotorPolicyData?.proposerDetails?.gstNumber,
          idProofType:
            buyMotorPolicyData?.proposerDetails?.idProofType,
          idProofNumber:
            buyMotorPolicyData?.proposerDetails?.idProofNumber,
          nationality:
            buyMotorPolicyData?.proposerDetails?.nationality,
          occupation: buyMotorPolicyData?.proposerDetails?.occupation,
          panNumber: buyMotorPolicyData?.proposerDetails?.panNumber,
          maritalStatus:
            buyMotorPolicyData?.proposerDetails?.maritalStatus,
          permAddressLine1:
            buyMotorPolicyData?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            buyMotorPolicyData?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            buyMotorPolicyData?.proposerDetails?.permAddressLine3,
          permLandmark:
            buyMotorPolicyData?.proposerDetails?.permLandmark,
          permPincode:
            buyMotorPolicyData?.proposerDetails?.permPincode,
          permCityTownVillage:
            buyMotorPolicyData?.proposerDetails?.permCityTownVillage,
          permDistrict:
            buyMotorPolicyData?.proposerDetails?.permDistrict,
          permState: buyMotorPolicyData?.proposerDetails?.permState,
          permCommAddressYN:
            buyMotorPolicyData?.proposerDetails?.permCommAddressYN,
          commAddressLine1:
            buyMotorPolicyData?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            buyMotorPolicyData?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            buyMotorPolicyData?.proposerDetails?.commAddressLine3,
          commLandmark:
            buyMotorPolicyData?.proposerDetails?.commLandmark,
          commPincode:
            buyMotorPolicyData?.proposerDetails?.commPincode,
          commCityTownVillage:
            buyMotorPolicyData?.proposerDetails?.commCityTownVillage,
          commDistrict:
            buyMotorPolicyData?.proposerDetails?.commDistrict,
          commState: buyMotorPolicyData?.proposerDetails?.commState,
          phoneNo: buyMotorPolicyData?.proposerDetails?.phoneNo,
          mobileNo: buyMotorPolicyData?.proposerDetails?.mobileNo,
          emailID: buyMotorPolicyData?.proposerDetails?.emailID,
          faxNo: buyMotorPolicyData?.proposerDetails?.faxNo,
          altPhoneNo: buyMotorPolicyData?.proposerDetails?.altPhoneNo,
          altMobileNo:
            buyMotorPolicyData?.proposerDetails?.altMobileNo,
          ifscCode: buyMotorPolicyData?.proposerDetailsMeta?.ifscCode,
          bankName: buyMotorPolicyData?.proposerDetailsMeta?.bankName,
          branchName:
            buyMotorPolicyData?.proposerDetailsMeta?.branchName,
          bankAcno: buyMotorPolicyData?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            buyMotorPolicyData?.proposerDetailsMeta
              ?.accountHolderName,
          micrCode: buyMotorPolicyData?.proposerDetailsMeta?.micrCode,
          employeeNumber:
            buyMotorPolicyData?.proposerDetails?.employeeNumber,
          agentID: '3106520000',
        },
        nomineeDetails: {
          name:
            buyMotorPolicyData?.additionalTabDetails?.nomineeDetails
              ?.nomineeName,
          dob:
            buyMotorPolicyData?.additionalTabDetails?.nomineeDetails
              ?.nomineeDob,
          relationshipWithInsured:
            buyMotorPolicyData?.additionalTabDetails?.nomineeDetails
              ?.relationshipWithNominee,
          nameOfAppointee:
            buyMotorPolicyData?.additionalTabDetails?.nomineeDetails
              ?.nameOfAppointee,
          relationshipWithAppointee:
            buyMotorPolicyData?.additionalTabDetails?.nomineeDetails
              ?.relationshipWithAppointee,
        },
        proposalNumber: buyMotorPolicyData?.proposalNumber,
        leadGenerator:
          buyMotorPolicyData?.reviewAndConfirmTabDetails
            ?.leadGenerator,
        proposalPaymentType:
          buyMotorPolicyData?.reviewAndConfirmTabDetails
            ?.proposalPaymentType,
        premiumBreakup: {
          idvYear1:
            buyMotorPolicyData?.premiumData?.idv1 !== null &&
            buyMotorPolicyData?.premiumData?.idv1 !== undefined &&
            buyMotorPolicyData?.premiumData?.idv1 !== ''
              ? parseFloat(buyMotorPolicyData?.premiumData?.idv1)
              : null,
          idvYear2:
            buyMotorPolicyData?.premiumData?.idv2 !== null &&
            buyMotorPolicyData?.premiumData?.idv2 !== undefined &&
            buyMotorPolicyData?.premiumData?.idv2 !== ''
              ? parseFloat(buyMotorPolicyData?.premiumData?.idv2)
              : null,
          idvYear3:
            buyMotorPolicyData?.premiumData?.idv3 !== null &&
            buyMotorPolicyData?.premiumData?.idv3 !== undefined &&
            buyMotorPolicyData?.premiumData?.idv3 !== ''
              ? parseFloat(buyMotorPolicyData?.premiumData?.idv3)
              : null,
          netODPremium:
            buyMotorPolicyData?.premiumData?.netODPremium !== null &&
            buyMotorPolicyData?.premiumData?.netODPremium !==
              undefined &&
            buyMotorPolicyData?.premiumData?.netODPremium !== ''
              ? parseFloat(
                  buyMotorPolicyData?.premiumData?.netODPremium,
                )
              : null,
          netTPPremium:
            buyMotorPolicyData?.premiumData?.netTPPremium !== null &&
            buyMotorPolicyData?.premiumData?.netTPPremium !==
              undefined &&
            buyMotorPolicyData?.premiumData?.netTPPremium !== ''
              ? parseFloat(
                  buyMotorPolicyData?.premiumData?.netTPPremium,
                )
              : null,
          loadingDiscount:
            buyMotorPolicyData?.premiumData?.loadingDiscount !==
              null &&
            buyMotorPolicyData?.premiumData?.loadingDiscount !==
              undefined &&
            buyMotorPolicyData?.premiumData?.loadingDiscount !== ''
              ? parseFloat(
                  buyMotorPolicyData?.premiumData?.loadingDiscount,
                )
              : null,
          netPremium:
            buyMotorPolicyData?.premiumData?.netPremium !== null &&
            buyMotorPolicyData?.premiumData?.netPremium !==
              undefined &&
            buyMotorPolicyData?.premiumData?.netPremium !== ''
              ? parseFloat(
                  buyMotorPolicyData?.premiumData?.netPremium,
                )
              : null,
          gst:
            buyMotorPolicyData?.premiumData?.gst !== null &&
            buyMotorPolicyData?.premiumData?.gst !== undefined &&
            buyMotorPolicyData?.premiumData?.gst !== ''
              ? parseFloat(buyMotorPolicyData?.premiumData?.gst)
              : null,
          stampDuty:
            buyMotorPolicyData?.premiumData?.stampDuty !== null &&
            buyMotorPolicyData?.premiumData?.stampDuty !==
              undefined &&
            buyMotorPolicyData?.premiumData?.stampDuty !== ''
              ? parseFloat(buyMotorPolicyData?.premiumData?.stampDuty)
              : null,
          totalPremium:
            buyMotorPolicyData?.premiumData?.totalPremium !== null &&
            buyMotorPolicyData?.premiumData?.totalPremium !==
              undefined &&
            buyMotorPolicyData?.premiumData?.totalPremium !== ''
              ? parseFloat(
                  buyMotorPolicyData?.premiumData?.totalPremium,
                )
              : null,
              NCB:
              buyMotorPolicyData?.premiumData?.NCB !== null &&
              buyMotorPolicyData?.premiumData?.NCB !==
                undefined &&
              buyMotorPolicyData?.premiumData?.NCB !== ''
                ? parseFloat(
                    buyMotorPolicyData?.premiumData?.NCB,
                  )
                : null,
          loading:
            buyMotorPolicyData?.premiumData?.loading &&
            buyMotorPolicyData?.premiumData?.loading?.length > 0
              ? buyMotorPolicyData?.premiumData?.loading
              : [],
          discount:
            buyMotorPolicyData?.premiumData?.discount &&
            buyMotorPolicyData?.premiumData?.discount?.length > 0
              ? buyMotorPolicyData?.premiumData?.discount
              : [],
        },
      },
    };
  };

  if (dataBuyMotorPolicy) {
    var buyMotorPolicy = dataBuyMotorPolicy?.buyMotorPolicy;
    var quoteData = buyMotorPolicy?.quoteData;
    var coverData = buyMotorPolicy?.coverData;
  }

  if (ListDetails) {
    var { ProposalPaymentTypeList } = ListDetails;
  }

  if (dataLobList) {
    var { lobProductList } = dataLobList;
  }

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
          `${returnType}`
        ]
      : '';
  };

  let proposalSummaryDataDesktopView = [
    {
      grid_data: [
        buyMotorPolicy?.quoteNumber
          ? {
              label: (
                <div className="flex justify-start mt-2 mb-0.5">
                  <Text
                    type="label"
                    className="flex justify-end items-end h-full"
                  >
                    Quotation Number
                  </Text>
                  {/*<Text className="text-secondary flex items-center">
                    <FontAwesomeIcon
                      icon={faExternalLinkAlt}
                      className="cursor-pointer ml-2 text-xs"
                      onClick={(_) =>
                        window.open(
                          `/quote/saved/${lobCode}/${
                            lobProductList?.find(
                              (lpl) =>
                                lpl?.lob_code?.toLowerCase() ===
                                lobCode?.toLowerCase(),
                            )?.lob_name
                          }/${productCode}/${productName}/${
                            buyMotorPolicy?.quoteNumber
                          }`,
                        )
                      }
                    />
                  </Text>*/}
                </div>
              ),
              colSpan: 1,
              text: (
                <Link
                  to={`/uiquote/saved/31/motor/${product_code}/${product_name}/${
                    buyMotorPolicy?.quoteNumber
                  }`}
                >
                  <Text className="text-secondary underline">
                    {buyMotorPolicy?.quoteNumber}
                  </Text>
                </Link>
              ),
            }
          : null,
        quoteData?.businessType
          ? {
              colSpan: 1,
              text: (
                <div className="flex justify-between mt-2">
                  <Text className="flex flex-col -space-y-1">
                    <Text severity="info" type="label">
                      Business Type
                    </Text>
                    <Text>{quoteData?.businessType}</Text>
                  </Text>
                </div>
              ),
            }
          : null,
        buyMotorPolicy?.proposalNumber
          ? {
              label: (
                <span className="text-primary">Proposal Number</span>
              ),
              colSpan: 1,
              text: <Text>{buyMotorPolicy?.proposalNumber}</Text>,
            }
          : null,
        buyMotorPolicy?.proposalStatus
          ? {
              label: (
                <span className="text-primary">Proposal Status</span>
              ),
              text: <Text>{buyMotorPolicy?.proposalStatus}</Text>,
              colSpan: 1,
            }
          : null,
        {
          label: (
            <div className="flex justify-start mt-2 mb-0.5">
              <Text
                type="label"
                className="flex justify-end items-end h-full"
              >
                Product Type
              </Text>
            </div>
          ),
          colSpan: 1,
          text: (
            <Text>{buyMotorPolicy?.quoteData?.productTypeValue
            ?buyMotorPolicy?.quoteData?.productTypeValue
          :buyMotorPolicy?.quoteData?.productType
        }</Text>
          ),
        },
        /* start of the change*/
        {
          label: 'Partner',
          colSpan: repeat,
          text: buyMotorPolicy?.intermediaryDetails
            ?.intermediaryName ? (
            <Text>
              {`${buyMotorPolicy?.intermediaryDetails?.intermediaryName}(${`${buyMotorPolicy?.intermediaryDetails?.code
                }`})`}
            </Text>
          ) : buyMotorPolicy?.intermediaryDetails
              ?.intermediaryCode ? (
            <Text>
              {buyMotorPolicy?.intermediaryDetails?.intermediaryCode}
            </Text>
          ) : (
            <Text severity={'neutral'}>Not Captured</Text>
          ),
        },
        {
          label: 'Branch Office',
          colSpan: repeat,
          text: buyMotorPolicy?.intermediaryDetails
            ?.branchOfficeName ? (
            <Text>
              {buyMotorPolicy?.intermediaryDetails?.branchOfficeName}
            </Text>
          ) : buyMotorPolicy?.intermediaryDetails?.location ? (
            <Text>
              {buyMotorPolicy?.intermediaryDetails?.location}
            </Text>
          ) : (
            <Text severity={'neutral'}>Not Captured</Text>
          ),
        },
        {
          label: 'Field User',
          colSpan: repeat,
          text: buyMotorPolicy?.intermediaryDetails?.fieldUserName ? (
            <Text>
              {buyMotorPolicy?.intermediaryDetails?.fieldUserName}
            </Text>
          ) : buyMotorPolicy?.intermediaryDetails?.fieldUserCode ? (
            <Text>
              {buyMotorPolicy?.intermediaryDetails?.fieldUserCode}
            </Text>
          ) : (
            <Text severity={'neutral'}>Not Captured</Text>
          ),
        },
        {
          label:  'Policy Start Date',
          colSpan: repeat,
          text:  buyMotorPolicy?.quoteData?.premiumData?.p_startdate ? (
            <Text>
              {buyMotorPolicy?.quoteData?.premiumData?.p_startdate }
            </Text>
          ) : buyMotorPolicy?.quoteData?.policy?.startDate  ? (
            <Text>
              {buyMotorPolicy?.quoteData?.policy?.startDate } 
            </Text>
          ) : buyMotorPolicy?.policy?.startDate  ? (
            <Text>
              {buyMotorPolicy?.policy?.startDate } 
            </Text>
          ) :  (
            <Text severity={'neutral'}>Not Captured</Text>
          ),
        },
        {
          label:  'Policy End Date',
          colSpan: repeat,
          text:  buyMotorPolicy?.quoteData?.premiumData?.p_enddate ? (
            <Text>
              {buyMotorPolicy?.quoteData?.premiumData?.p_enddate }
            </Text>
          ) : buyMotorPolicy?.quoteData?.policy?.expiryDate  ? (
            <Text>
              {buyMotorPolicy?.quoteData?.policy?.expiryDate }
            </Text>
          ) : buyMotorPolicy?.policy?.endDate  ? (
            <Text>
              {buyMotorPolicy?.policy?.endDate }
            </Text>
          ) : (
            <Text severity={'neutral'}>Not Captured</Text>
          ),
        },
        (productCode?.toString() !== '3176') 
        ? {
          label:  'NCB %',
          colSpan: repeat,
          text:  buyMotorPolicy?.quoteData?.premiumData?.NCB ? (
            <Text>
              { buyMotorPolicy?.quoteData?.premiumData?.NCB }
            </Text>
          ) : buyMotorPolicy?.quoteData?.NCB ? (
            <Text>
              { buyMotorPolicy?.quoteData?.NCB }
            </Text>
          ) : (
            <Text severity={'neutral'}>Not Captured</Text>
          ),
        } : null,
        {
          label:  'Credit Score',
          colSpan: repeat,
          text:  buyMotorPolicy?.quoteData?.creditScore? (
            <Text>
              { buyMotorPolicy?.quoteData?.creditScore }
            </Text>
          ) :  buyMotorPolicy?.premiumData?.creditScore ? (
            <Text>
              { buyMotorPolicy?.premiumData?.creditScore }
            </Text>
          ) : (
            <Text severity={'neutral'}>Not Captured</Text>
          ),
        },
        /* end of the change */
        {
          text: (
            <Text
              className="quanta_link cursor-pointer mt-1"
              onClick={(_) => setShowCoversModal(true)}
              type="label"
            >
              View Add-on Covers
            </Text>
          ),
        },
        buyMotorPolicy?.proposalPaymentType
          ? {
              label: (
                <span className="text-primary">Proposal Type</span>
              ),
              text: (
                <>
                  {ProposalPaymentTypeList && (
                    <Text>
                      {getDomainData(
                        ProposalPaymentTypeList,
                        buyMotorPolicy.proposalPaymentType,
                        'code',
                        'value',
                      )}
                    </Text>
                  )}
                </>
              ),
              colSpan: 1,
            }
          : null,
        quoteData?.changedIDV
          ? {
              label: <span className="text-primary">IDV</span>,
              text: <Text>{CurrencyFormater(quoteData?.changedIDV)}</Text>,
            }
          : null,
        quoteData?.premiumData?.tenure || quoteData?.tenure
          ? {
              label: <span className="text-primary">Tenure</span>,
              text: (
                <Text>
                  {`${
                    quoteData?.premiumData?.tenure ||
                    quoteData?.tenure
                  }${
                    (
                      quoteData?.premiumData?.tenure ||
                      quoteData?.tenure
                    )?.search('years') === -1
                      ? ` year${
                          (quoteData?.premiumData?.tenure ||
                            quoteData?.tenure) === '1'
                            ? ''
                            : 's'
                        }`
                      : ''
                  }
                  `}
                </Text>
              ),
            }
          : null,
          //SA975
        (buyMotorPolicy?.premiumData?.totalPremium || buyMotorPolicy?.premiumData?.finalpremium)||
        (quoteData?.premiumData?.totalPremium || quoteData?.premiumData?.finalpremium)
        //EA975
          ? {
              label: (
                <span className="text-primary">
                  Annual Premium (inclusive of all taxes)
                </span>
              ),
              colSpan: 1,
              text: (
                <div className="flex justify-start space-x-2 mt-1">
                  <span>
                    <Text
                      type="larger"
                      severity="info"
                      className="mt-0.5"
                    >
                      {CurrencyFormater(
                        //SA975
                        (buyMotorPolicy?.premiumData?.totalPremium || buyMotorPolicy?.premiumData?.finalpremium) ||
                        (quoteData?.premiumData?.totalPremium || quoteData?.premiumData?.finalpremium),
                          //EA975
                      )}
                    </Text>
                  </span>
                  <span className="mt-2.5">
                    <Text
                      severity="action"
                      type="label"
                      className="quanta_link cursor-pointer mt-1"
                      onClick={(_) => {
                        setShowViewBreakup(true);
                      }}
                    >
                      View Breakup
                    </Text>
                  </span>
                </div>
              ),
            }
          : null,
        {
          text: (
            <span className="flex flex-col items-end justify-end py-3 w-full h-full">
              <Button
                flat={true}
                type={'button'}
                disabled={
                  !dataBuyMotorPolicy?.buyMotorPolicy?.proposalNumber
                    .length > 0 || loadingDownload
                }
                size="medium"
                className="w-full"
                onClick={async (_) => {
                  try {
                    let getDateTime = fetchQuery({
                      query: GET_DATE_TIME,
                    });
                    setAlerts([]);
                    setLoadingDownload(true);

                    let { data: getDateTimeData } = await getDateTime;

                    let proposalPDFBase64String = mutateQuery({
                      mutation: SEND_PROPOSAL_PDF,
                      variables: getBase64Var(
                        buyMotorPolicy,
                        getDateTimeData,
                      ),
                    });

                    let {
                      data: dataBase64String,
                    } = await proposalPDFBase64String;
                    const { sendProposalPDFTW } = dataBase64String;
                    const {
                      base64Pdf: downloadBase64String,
                    } = sendProposalPDFTW;
                    setLoadingDownload(false);

                    let byteCharacters = atob(
                      downloadBase64String.toString(),
                    );
                    let byteNumbers = new Array(
                      byteCharacters.length,
                    );
                    for (let i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], {
                      type: 'application/pdf;base64',
                    });
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                  } catch (error) {
                    setAlerts([
                      {
                        id: Date.now(),
                        content: (
                          <div className="flex flex-col w-full h-full">
                            <Text type="normal">{error.message}</Text>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                    setLoadingDownload(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={loadingDownload ? faSpinner : faDownload}
                  className="mr-4"
                  spin={loadingDownload}
                  size="lg"
                />
                {loadingDownload
                  ? 'Downloading...'
                  : 'Download Proposal Form'}
              </Button>
            </span>
          ),
          colSpan: 1,
        },
      ].filter((d) => d),
    },
  ];

  let proposalSummaryDataMobileView = [
    {
      grid_data: [
        //SA975
        (buyMotorPolicy?.premiumData?.totalPremium || buyMotorPolicy?.premiumData?.finalpremium) ||
        (quoteData?.premiumData?.totalPremium ||
        quoteData?.premiumData?.finalpremium)
        //EA975
          ? {
              label: (
                <span className="text-primary">Annual Premium</span>
              ),
              text: (
                <div className="flex justify-start space-x-2 mt-1 items-center">
                  <span>
                    <Text
                      type="larger"
                      severity="info"
                      className="mt-0.5"
                    >
                      {CurrencyFormater(
                        //SA975
                        (buyMotorPolicy?.premiumData?.totalPremium || buyMotorPolicy?.premiumData?.finalpremium) ||
                          (quoteData?.premiumData?.totalPremium ||
                          quoteData?.premiumData?.finalpremium),
                          //EA975
                      )}
                    </Text>
                  </span>
                  <span>
                    <Text
                      severity="info"
                      className="cursor-pointer"
                      onClick={(_) => {
                        setShowViewBreakup(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Text>
                  </span>
                </div>
              ),
            }
          : null,
        {
          className:
            screenType?.toString()?.toLowerCase() === 'ipad'
              ? ''
              : '',
          text: (
            <Text>
              <Button
                type={'button'}
                iconPre={
                  <FontAwesomeIcon
                    icon={faEye}
                    className="mr-3"
                    size="lg"
                  />
                }
                flat={true}
                size={'small'}
                className="mt-6 h-8"
                onClick={(_) => setShowCoversModal(true)}
              >
                Add On Covers
              </Button>
            </Text>
          ),
        },
        {
          label: (
            <span className="text-primary">Proposal Number</span>
          ),
          colSpan: 1,
          text: (
            <div className="flex flex-col">
              {buyMotorPolicy?.proposalNumber ? (
                <>
                  <Text>{buyMotorPolicy?.proposalNumber}</Text>
                </>
              ) : (
                <Text severity="neutral-darker" className="mt-0.5">
                  Not Captured
                </Text>
              )}
            </div>
          ),
        },
        {
          className:
            screenType?.toString()?.toLowerCase() === 'ipad'
              ? ''
              : '',
          text: (
            <Text>
              <Button
                flat={true}
                type={'button'}
                size={'small'}
                className={
                  !dataBuyMotorPolicy?.buyMotorPolicy?.proposalNumber
                    .length > 0 || loadingDownload
                    ? 'mt-4 h-8 border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                    : 'mt-4 h-8'
                }
                onClick={async (_) => {
                  if (
                    !dataBuyMotorPolicy?.buyMotorPolicy
                      ?.proposalNumber.length > 0 ||
                    loadingDownload
                  ) {
                    return;
                  }
                  try {
                    let getDateTime = fetchQuery({
                      query: GET_DATE_TIME,
                    });
                    setAlerts([]);
                    setLoadingDownload(true);

                    let { data: getDateTimeData } = await getDateTime;

                    let proposalPDFBase64String = mutateQuery({
                      mutation: SEND_PROPOSAL_PDF,
                      variables: getBase64Var(
                        buyMotorPolicy,
                        getDateTimeData,
                      ),
                    });

                    let {
                      data: dataBase64String,
                    } = await proposalPDFBase64String;
                    const { sendProposalPDFTW } = dataBase64String;
                    const {
                      base64Pdf: downloadBase64String,
                    } = sendProposalPDFTW;
                    setLoadingDownload(false);

                    let byteCharacters = atob(
                      downloadBase64String.toString(),
                    );
                    let byteNumbers = new Array(
                      byteCharacters.length,
                    );
                    for (let i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], {
                      type: 'application/pdf;base64',
                    });
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                  } catch (error) {
                    setAlerts([
                      {
                        id: Date.now(),
                        content: (
                          <div className="flex flex-col w-full h-full">
                            <Text type="normal">{error.message}</Text>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                    setLoadingDownload(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={loadingDownload ? faSpinner : faDownload}
                  className="mr-2"
                  spin={loadingDownload}
                  size="lg"
                />
                {loadingDownload ? 'Downloading...' : 'Download Form'}
              </Button>
            </Text>
          ),
        },
      ].filter((b) => b),
    },
  ];

  let proposalSummaryDataiPadView = [
    {
      grid_data: [
        //SA975
        (buyMotorPolicy?.premiumData?.totalPremium || buyMotorPolicy?.premiumData?.finalpremium) ||
        (quoteData?.premiumData?.totalPremium ||
        quoteData?.premiumData?.finalpremium)
        //EA975
          ? {
              label: (
                <span className="text-primary">Annual Premium</span>
              ),
              text: (
                <div className="flex justify-start space-x-2 items-center">
                  <span>
                    <Text
                      type="larger"
                      severity="info"
                      className="mt-0.5"
                    >
                      {CurrencyFormater(
                        //SA975
                        (buyMotorPolicy?.premiumData?.totalPremium || buyMotorPolicy?.premiumData?.finalpremium) ||
                          (quoteData?.premiumData?.totalPremium ||
                          quoteData?.premiumData?.finalpremium),
                          //EA975
                      )}
                    </Text>
                  </span>
                  <span>
                    <Text
                      severity="info"
                      className="cursor-pointer"
                      onClick={(_) => {
                        setShowViewBreakup(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Text>
                  </span>
                </div>
              ),
            }
          : null,
        {
          className: 'mt-0.5',
          label: (
            <span className="text-primary">Proposal Number</span>
          ),
          colSpan: 1,
          text: (
            <div className="flex flex-col">
              {buyMotorPolicy?.proposalNumber ? (
                <>
                  <Text>{buyMotorPolicy?.proposalNumber}</Text>
                </>
              ) : (
                <Text severity="neutral-darker" className="mt-0.5">
                  Not Captured
                </Text>
              )}
            </div>
          ),
        },
        {
          text: (
            <Text>
              <Button
                type={'button'}
                iconPre={
                  <FontAwesomeIcon
                    icon={faEye}
                    className="mr-2"
                    size="lg"
                  />
                }
                flat={true}
                size={'small'}
                className="mt-5 h-8 border-none focus:outline-none"
                onClick={(_) => setShowCoversModal(true)}
              >
                <Text>View Add On Covers</Text>
              </Button>
            </Text>
          ),
        },
        {
          text: (
            <Text>
              <Button
                flat={true}
                type={'button'}
                size={'small'}
                className={
                  !dataBuyMotorPolicy?.buyMotorPolicy?.proposalNumber
                    .length > 0 || loadingDownload
                    ? 'mt-5 ml-4 h-8 border-none text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                    : 'mt-5 h-8 ml-4 border-none'
                }
                onClick={async (_) => {
                  if (
                    !dataBuyMotorPolicy?.buyMotorPolicy
                      ?.proposalNumber.length > 0 ||
                    loadingDownload
                  ) {
                    return;
                  }
                  try {
                    let getDateTime = fetchQuery({
                      query: GET_DATE_TIME,
                    });
                    setAlerts([]);
                    setLoadingDownload(true);

                    let { data: getDateTimeData } = await getDateTime;

                    let proposalPDFBase64String = mutateQuery({
                      mutation: SEND_PROPOSAL_PDF,
                      variables: getBase64Var(
                        buyMotorPolicy,
                        getDateTimeData,
                      ),
                    });

                    let {
                      data: dataBase64String,
                    } = await proposalPDFBase64String;
                    const { sendProposalPDFTW } = dataBase64String;
                    const {
                      base64Pdf: downloadBase64String,
                    } = sendProposalPDFTW;
                    setLoadingDownload(false);

                    let byteCharacters = atob(
                      downloadBase64String.toString(),
                    );
                    let byteNumbers = new Array(
                      byteCharacters.length,
                    );
                    for (let i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], {
                      type: 'application/pdf;base64',
                    });
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                  } catch (error) {
                    setAlerts([
                      {
                        id: Date.now(),
                        content: (
                          <div className="flex flex-col w-full h-full">
                            <Text type="normal">{error.message}</Text>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                    setLoadingDownload(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={loadingDownload ? faSpinner : faDownload}
                  className="mr-2"
                  spin={loadingDownload}
                  size="lg"
                />
                <Text>
                  {loadingDownload
                    ? 'Downloading...'
                    : 'Download Form'}
                </Text>
              </Button>
            </Text>
          ),
        },
      ].filter((b) => b),
    },
  ];

  return (
    <>
      {list_loading || loadingLobList ? (
        <Loading />
      ) : error_list || errorLobList ? (
        <Error error={error_list || errorLobList} />
      ) : (
        <div>
          <DataGridGroup
            data={
              repeat === repeatForDesktop
                ? proposalSummaryDataDesktopView
                : repeat === repeatForMobile
                ? proposalSummaryDataMobileView
                : proposalSummaryDataiPadView
                ? proposalSummaryDataiPadView
                : null
            }
            repeat={repeat}
            textType="label"
            titleType="title"
            titleSeverity="info"
            className="w-full"
            gap={0}
            gapX={16}
            isSeparatorRequired={false}
            gapY={2}
            spaceY={2}
          />
          <ModalViewBreakupTW
            {...{
              showViewBreakup,
              setShowViewBreakup,
              productName,
              productCode,
              lobCode,
              lobName,
              productType,
              premiumBreakupFor: 'Proposal',
              breakupData: {
                premiumData: buyMotorPolicy?.premiumData?.finalpremium || buyMotorPolicy?.premiumData?.totalPremium//SA975
                  ? buyMotorPolicy?.premiumData
                  : buyMotorPolicy?.quoteData?.premiumData,
                tenure:
                  buyMotorPolicy?.premiumData?.tenure ||
                  buyMotorPolicy?.quoteData?.premiumData?.tenure ||
                  buyMotorPolicy?.quoteData?.tenure,
                make: {
                  code:
                    buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                      ?.make?.code ||
                    buyMotorPolicy?.quoteData?.make?.code,
                  value:
                    buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                      ?.make?.value ||
                    buyMotorPolicy?.quoteData?.make?.value,
                },
                model: {
                  code:
                    buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                      ?.model?.code ||
                    buyMotorPolicy?.quoteData?.model?.code,
                  value:
                    buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                      ?.model?.value ||
                    buyMotorPolicy?.quoteData?.model?.value,
                },
                variant: {
                  code:
                    buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                      ?.variant?.code ||
                    buyMotorPolicy?.quoteData?.variant?.code,
                  value:
                    buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                      ?.variant?.value ||
                    buyMotorPolicy?.quoteData?.variant?.value,
                },
                fuelType:
                  buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                    ?.fuelType || buyMotorPolicy?.quoteData?.fuelType,
                cubicCapacity:buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                    ?.cubeCapacity || buyMotorPolicy?.quoteData?.cubeCapacity,
                segmentType:buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                    ?.segmentType || buyMotorPolicy?.quoteData?.segmentType,
                dateOfReg:
                  buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                    ?.dateOfRegistration ||
                  buyMotorPolicy?.quoteData?.dateOfReg,
                rtoAuthorityCode:
                  buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                    ?.rtoDetails?.rtoAuthorityCode ||
                  buyMotorPolicy?.quoteData?.rtoAuthorityCode,
                rtoLocationDesc:
                  buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
                    ?.rtoDetails?.rtoLocationDesc ||
                  buyMotorPolicy?.quoteData?.rtoLocationDesc,
                coverData : buyMotorPolicy?.quoteData?.coverData,
              },
            }}
          />
          <CoverDataModal
            {...{
              setShowCoversModal,
              showCoversModal,
              quoteData,
              coverData,
              lobCode,
              lobName,
              productCode,
              productName,
              productType,
            }}
          />
          <div>
            <NotificationList {...{ items: alerts }} />
          </div>
        </div>
      )}
    </>
  );
}
